module.exports = __webpack_public_path__ + "files/79aa6f45a36b693ab3c8e5769b8591bf.png";